import React from 'react';
import s from './Spinner.module.css';
const Spinner = ({ color }: { color?: 'green' | 'red' }) => {
    let spinnerClass = s.loading_spinner;
    if (color === 'green') spinnerClass = s.loading_spinner_green;
    if (color === 'red') spinnerClass = s.loading_spinner_red;
    return (
        <div className={s.loading_container}>
            <div className={spinnerClass} />
        </div>
    );
};

export default Spinner;
